import { BasePage } from './BasePage';
import { clearSignupStateValues } from './new/signup/signup_helpers';
import Utils from "../common/Utils";
import {clearAuthToken, setAuthToken} from "../common/authtoken";
import {disconnect, googleDoLogin} from "../common/api";
import {BASE_PATH} from "../config";

const name = 'login';

class LoginPage extends BasePage {
	constructor() {
		super(name, true);
	}

	initStateValues() {
		const state = JSON.parse(localStorage.getItem('state'));
		if (state?.quiz) {
			state.quiz.isActivityModalVisible = false;
			localStorage.setItem('state', JSON.stringify(state));
		}
		clearSignupStateValues();
	}

	async load() {
		super.load();
		const urlParams = new URLSearchParams(window.location.search);
		const invalidate = urlParams.get('invalidate') === 'true'
		const message = urlParams.get('message');
		if (message) {
			try{
				document.getElementById('loginForm-errors').innerHTML = `<ul class="errors" role="note"><li>${message}</li></ul>`
			} catch (e) {
				console.error(e);
			}
		}
		if (invalidate) {
			clearAuthToken()
			await disconnect()
		} else {
			let token = Utils.getTokenFromEnv()
			if (token) {
				this.initStateValues();
				setAuthToken(token);
				localStorage.clearItem('token');
				const res = await googleDoLogin();
				history.pushState({loginProvider: 'username'}, null, BASE_PATH + res.url);
				location.reload();
			}
		}
	}
}

export default new LoginPage();
